import { render, staticRenderFns } from "./FeaturedList.vue?vue&type=template&id=cb1ec2c4&scoped=true&"
import script from "./FeaturedList.vue?vue&type=script&lang=js&"
export * from "./FeaturedList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedList.vue?vue&type=style&index=0&id=cb1ec2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ec2c4",
  null
  
)

export default component.exports